import { attr, belongsTo, hasMany } from '@ember-data/model';
import classic from 'ember-classic-decorator';

import UnauthenticatedAppointmentModel from './unauthenticated-appointment';

@classic
export default class Appointment extends UnauthenticatedAppointmentModel {
  @belongsTo('treatable-client', { polymorphic: true, async: false }) client;
  @belongsTo('card', { async: false }) card;
  @hasMany('invoice-item', { async: false }) invoiceItems;
  @belongsTo('superbill', { async: false, inverse: 'appointments' }) superbill;
  @belongsTo('appointment-client', { async: false }) appointmentClient;
  @attr() schedulingSource;
  @attr() uninvoicedFee;
  @attr() billableDescription;
  @attr() channel;
  @attr() mld;
  @attr() fee;
  @attr() cptCodes;
  @attr() units;
  @attr() clinicianReferral;
  @attr() marketingClickIds;
  @attr() source;
  @attr() therapyfinderFlow;
  @attr() referralChannel;
  @attr() datagrailConsentPreferences;

  get displayStatus() {
    if (this.isPastDue) {
      return 'past due';
    } else if (this.paid) {
      return 'paid';
    } else {
      return 'unpaid';
    }
  }

  get badgeClass() {
    if (this.isPastDue) {
      return 'primary wine';
    } else if (this.paid) {
      return 'secondary mint';
    } else {
      return 'secondary wine';
    }
  }

  get totalAllocatedAmount() {
    return this.invoiceItems.reduce((total, invoiceItem) => {
      return total + invoiceItem.allocatedAmount;
    }, 0);
  }

  get paid() {
    const invoices = this.uniqueInvoices;
    return invoices.length > 0 && invoices.every(invoice => invoice.isPaid);
  }

  get isPastDue() {
    return this.uniqueInvoices.some(invoice => invoice.isPastDue);
  }

  get uniqueInvoices() {
    return this.invoiceItems.map(invoiceItem => invoiceItem.invoice).uniqBy('id');
  }
}
